<template>
	<div>
		<div class="row">
			<div
				class="col-md-4 col-xs-6 form-group"
				:class="{'has-error': erro.identificacao_voo != null}"
			>
				<label>* {{ _traducao('global', 'identificacaoVoo') }}:</label>
				<input
					type="text"
					class="form-control input-sm"
					v-model="form.identificacao_voo"
				/>
				<p class="help-block" v-if="erro.identificacao_voo != null">
					{{ erro.identificacao_voo }}
				</p>
			</div>
			<div
				class="col-md-4 col-xs-6 form-group"
				:class="{'has-error': erro.id_orgao != null}"
			>
				<label>* {{ labelOrgaoApoiado }}:</label>
				<select v-model="form.orgao" class="form-control input-sm">
					<option value="0">
						{{ _traducao('global', 'escolha').toUpperCase() }}
					</option>
					<option
						v-for="orgaoApoiado in orgaosApoiados"
						:key="orgaoApoiado.id"
						:value="orgaoApoiado"
					>
						{{ orgaoApoiado.descricao }}
					</option>
				</select>
				<p class="help-block" v-if="erro.id_orgao != null">
					{{ erro.id_orgao }}
				</p>
			</div>
			<div
				v-if="!ativarClassificacao"
				class="col-md-4 col-xs-6 form-group"
				:class="{'has-error': erro.id_tipo_missao != null}"
			>
				<label> * {{ _traducao('global', 'naturezaDoVoo') }}: </label>
				<select v-model="form.id_tipo_missao" class="form-control input-sm">
					<option value="0">
						{{ _traducao('global', 'escolha').toUpperCase() }}
					</option>
					<option
						v-for="tipoMissao in tiposMissao"
						:key="tipoMissao.descricao"
						:value="tipoMissao.id"
					>
						{{ tipoMissao.descricao }}
					</option>
				</select>
				<p class="help-block" v-if="erro.id_tipo_missao != null">
					{{ erro.id_tipo_missao }}
				</p>
			</div>
		</div>
		<div class="row" v-if="ativarClassificacao">
			<div
				class="col-md-4 col-xs-6 form-group"
				:class="{'has-error': erro.classificacao != null}"
			>
				<label>* {{ _traducao('global', 'classificacao') }}:</label>
				<v-select
					v-model="form.classificacao"
					class="form-control input-sm"
					:options="classificacoes"
					label="descricao"
					@change="filtraSubclassificacao()"
				></v-select>
				<p class="help-block" v-if="erro.classificacao != null">
					{{ erro.classificacao }}
				</p>
			</div>
			<div
				class="col-md-4 col-xs-6 form-group"
				:class="{'has-error': erro.subclassificacao != null}"
			>
				<label>* {{ _traducao('global', 'subclassificacao') }}:</label>
				<form>
					<v-select
						v-model="form.subclassificacao"
						class="form-control input-sm"
						:options="subclassificacoesAux"
						label="_descricao"
					></v-select>
				</form>
				<p class="help-block" v-if="erro.subclassificacao != null">
					{{ erro.subclassificacao }}
				</p>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12 form-group">
				<label>{{ _traducao('global', 'historico') }}:</label>
				<textarea
					rows="4"
					class="form-control input-sm"
					v-model="form.historico"
				></textarea>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		form: {
			type: Object,
			required: true
		},
		erro: {
			type: Object,
			required: true
		},
		subclassificacoes: {
			type: Array,
			required: true
		},
		classificacoes: {
			type: Array,
			required: true
		},
		tiposMissao: {
			type: Array,
			required: true
		},
		orgaosApoiados: {
			type: Array,
			required: true
		},
		ativarClassificacao: {
			type: Boolean,
			required: true
		}
	},

	computed: {},

	data() {
		return {
			labelOrgaoApoiado: 'Centro de Custo',
			subclassificacoesAux: []
		}
	},

	created() {
		this.parametros()
	},

	methods: {
		filtraSubclassificacao() {
			this.subclassificacoesAux = []
			this.subclassificacoesAux = this.subclassificacoes.filter((item) => {
				return item.id_classificacao == this.form.classificacao.id
			})
		},
		parametros() {
			this._getParametro(66).then((valor) => (this.labelOrgaoApoiado = valor))
		}
	}
}
</script>